"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineRequest = void 0;
var OnlineRequest = /** @class */ (function () {
    function OnlineRequest() {
    }
    return OnlineRequest;
}());
exports.OnlineRequest = OnlineRequest;
;
//# sourceMappingURL=online.request.js.map